import { useState, useEffect } from "react";
import { Menu, X, Clapperboard } from "lucide-react";
import { Link } from "react-router-dom";

const links = [
  { label: "How it Works", href: "#how-it-works", testid: "nav-how-it-works-link" },
  { label: "Portfolio", href: "#portfolio", testid: "nav-portfolio-link" },
  { label: "Pricing", href: "#pricing", testid: "nav-pricing-link" },
  { label: "FAQ", href: "#faq", testid: "nav-faq-link" },
];

export const Navbar = ({ onCreate }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? "itm-glass border-b border-white/10" : ""}`}>
      <nav className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 h-16 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2 group">
          <span className="relative grid place-items-center w-9 h-9 rounded-xl bg-[#FF2E63] itm-pulse">
            <Clapperboard className="w-5 h-5 text-white" />
          </span>
          <span className="font-display font-extrabold text-lg tracking-tight">
            iTMunch<span className="text-[#FF2E63]">.</span>
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a key={l.href} href={l.href} data-testid={l.testid}
               className="text-sm text-slate-300 hover:text-white transition-colors">
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link to="/admin" data-testid="nav-admin-login-button"
                className="text-sm text-slate-400 hover:text-white transition-colors">
            Admin
          </Link>
          <button data-testid="nav-create-video-button" onClick={onCreate}
                  className="rounded-full bg-[#FF2E63] hover:bg-[#E02554] text-white text-sm font-semibold px-5 py-2.5 transition-colors">
            Create My Video
          </button>
        </div>

        <button className="md:hidden text-white" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden itm-glass border-b border-white/10 px-6 py-4 flex flex-col gap-4">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-slate-200">{l.label}</a>
          ))}
          <Link to="/admin" className="text-slate-400">Admin</Link>
          <button onClick={() => { setOpen(false); onCreate(); }}
                  className="rounded-full bg-[#FF2E63] text-white font-semibold px-5 py-2.5">
            Create My Video
          </button>
        </div>
      )}
    </header>
  );
};
